export const OrderHeadOfficePage = () => {
  return <>OrderHeadOfficePage</>;
};
